import { BridgeComponent } from '@hotwired/hotwire-native-bridge'
import { submitForm } from '../../utils/bridge_form'
import { visitInPlace } from '../../turbo/in_place_visit'
import { withIconSvg } from '../../utils/bridge_icons'

// Menu ⋯ natif de la nav bar (MenuComponent iOS). `items` : le contrat détaillé
// est dans MenuComponent.swift — `confirmLabel` / `cancelLabel` y nomment les
// boutons du dialogue de confirmation (cf. `bridge_confirm_labels`). `label` :
// le libellé VoiceOver du bouton ⋯, traduit par Rails. Sur Android, chaque item (et
// sous-item) part avec `svg`, le dessin de son icône (utils/bridge_icons).
//
// `haptic` (optionnel, par item) : retour haptique natif sur une action non-GET, porté
// par le formulaire injecté pour que bridge--haptic le ramasse (types dans son
// contrôleur). Opt-in comme sur bridge--button : une action destructive n'a pas à
// vibrer comme une confirmation. Le champ ne sert que côté web, le natif ne le décode pas.
export default class extends BridgeComponent {
  static component = 'menu'
  static values = { items: Array, label: String }

  connect() {
    super.connect()
    this.pagePath = window.location.pathname
    this.#sendConnect()
    // Rendu document caché (remise à zéro d'un onglet en arrière-plan…) : le
    // connect est ignoré par le bridge (destination inactive) et le bouton natif
    // resterait câblé sur la page morte. On rejoue au native:appeared du
    // réaffichage — UNIQUEMENT dans ce cas : un double connect systématique
    // ouvrirait des courses de doublons dans la nav bar.
    if (document.visibilityState === 'hidden') {
      // Only for the page this controller belongs to: during a visit, the URL
      // changes before the old body is replaced, and its controllers still live.
      this.appearedHandler = () => { if (window.location.pathname === this.pagePath) this.#sendConnect() }
      window.addEventListener('native:appeared', this.appearedHandler, { once: true })
    }
  }

  disconnect() {
    window.removeEventListener('native:appeared', this.appearedHandler)
    super.disconnect()
  }

  #sendConnect() {
    const items = this.itemsValue.map(withIconSvg)
    this.send('connect', { items, label: this.labelValue }, (message) => {
      this.#handleSelection(message.data.index, message.data.childIndex)
    })
  }

  // `childIndex` cible un item de sous-menu (`children`, ex. « Trier par »).
  #handleSelection(index, childIndex) {
    let item = this.itemsValue[index]
    if (item && childIndex != null) item = item.children?.[childIndex]
    if (!item) return

    // `click` : délègue à un bouton web existant (ex. Organiser → activation
    // sortable in-place) au lieu de naviguer.
    if (item.click) {
      document.querySelector(item.click)?.click()
      return
    }

    const method = (item.method || 'get').toLowerCase()
    if (method === 'get') {
      // `visit: 'replace'` : changement de tri — la page se remplace en place,
      // sans nouvel écran natif, défilement gardé (cf. `turbo/in_place_visit`).
      if (item.visit === 'replace') visitInPlace(item.url, null)
      else window.Turbo.visit(item.url)
    } else {
      submitForm(item.url, method, { haptic: item.haptic })
    }
  }
}
